var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "copy-content-detection-dialog",
      style: { right: _vm.getRight },
    },
    [
      _c("div", { staticClass: "copy-content-detection-header" }, [
        _c(
          "div",
          { staticClass: "title-header flex flex-between flex-middle" },
          [
            _c("span", [_vm._v("发现文案提取链接")]),
            _c("img", {
              staticClass: "close-img",
              attrs: {
                src: require("@/assets/image/copyContentDetectionDialog/close.png"),
                alt: "",
              },
              on: {
                click: function ($event) {
                  _vm.isShow = false
                },
              },
            }),
          ]
        ),
        _c("div", { staticClass: "divider-header" }),
      ]),
      _c(
        "div",
        { staticClass: "copy-content-detection-row flex flex-middle" },
        [
          _c("span", { staticClass: "label" }, [_vm._v("链接来源：")]),
          _c("div", { staticClass: "text" }, [_vm._v(_vm._s(_vm.getTypeText))]),
        ]
      ),
      _c("div", { staticClass: "copy-content-detection-row flex flex-left" }, [
        _c("span", { staticClass: "label" }, [_vm._v("链接内容：")]),
        _c("div", { staticClass: "text" }, [_vm._v(_vm._s(_vm.text))]),
      ]),
      _c(
        "div",
        { staticClass: "footer_btn flex flex-right flex-middle" },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.openAI } },
            [_vm._v("一键提取文案")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }